// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import React from 'react'
import stylesDef from './styles';
import moment from 'moment';
import { LEDGER_TYPE_TEXT, LEDGER_TYPES } from 'Utils/constants';
import { GetAdminProjectRoute } from 'Utils/routes';
import { useNavigate, useParams } from 'react-router-dom';

interface CreditUsageLedgerCardProps {
  creditUsageLedger: ICreditUsageLedger;
}

const CreditUsageLedgerCard = ({ creditUsageLedger }: CreditUsageLedgerCardProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);
  const navigate = useNavigate();
  const { orgId } = useParams();
  
  //Methods
  const getLedgerTypeText = (type: string) => {
    if (type === LEDGER_TYPES.order) {
      return creditUsageLedger.orderNumber ? `${creditUsageLedger.projectName}, Order ${creditUsageLedger.orderNumber}` : `${creditUsageLedger.projectName}`;
    }
    return LEDGER_TYPE_TEXT[type];
  }

  const formatNumber = (number: number | string) => {
    if (number === undefined || number === null) return '';
    const num = typeof number === 'string' ? parseFloat(number) : number;
    return num.toLocaleString('en-US');
  }

  const getCreditAcerageClass = (type: string, creditAcerage: number) => {
    if (type === LEDGER_TYPES.order) {
      if (creditAcerage !== 0) {
        return styles.orderCredit;
      } else {
        return null;
      }
    }
    return styles.subscriptionCredit;
  }

  const getPositiveOrNegativeSignForCreditAcerage = (type: string, creditAcerage: number) => {
    if (creditAcerage !== 0) {
      return type === LEDGER_TYPES.subscription ? '+' : '-';
    }
    return '';
  }

  const handleViewProjectClick = () => {
    navigate(GetAdminProjectRoute(orgId, creditUsageLedger.ownerProject));
  };

  return (
    <Box sx={styles.cardWrapper}>
      <Box sx={styles.card}>
        <Box sx={styles.cardHeader}>
          <Box sx={styles.cardHeaderLeft}>
            <Typography variant="h4" sx={getCreditAcerageClass(creditUsageLedger.type, creditUsageLedger.creditAcerage)}>{ `${getPositiveOrNegativeSignForCreditAcerage(creditUsageLedger.type, creditUsageLedger.creditAcerage)}${formatNumber(creditUsageLedger.creditAcerage)}`}</Typography>
            <Box>|</Box>
            <Typography variant="body1">{getLedgerTypeText(creditUsageLedger.type)}</Typography>
            {creditUsageLedger.type === LEDGER_TYPES.order && <Button variant="text" color="primary" onClick={handleViewProjectClick}>View Project</Button>}
          </Box>
          <Box sx={styles.cardHeaderRight}>
            <Typography variant="body1">{moment(creditUsageLedger.updatedAt).format('MMM DD, YYYY hh:mm A')}</Typography>
          </Box>
        </Box>
        <Divider sx={styles.divider} />
        <Box sx={styles.cardContent}>
          <Typography variant="body1">Available Credits: </Typography>
          <Typography variant="h4">{creditUsageLedger.remainingAvailableCredits || 'N/A'}</Typography>
        </Box>  
      </Box>
    </Box>
  )
}

export default CreditUsageLedgerCard